import { render, staticRenderFns } from "./leftPage.vue?vue&type=template&id=dc9ee224&scoped=true"
import script from "./leftPage.vue?vue&type=script&lang=js"
export * from "./leftPage.vue?vue&type=script&lang=js"
import style0 from "./leftPage.vue?vue&type=style&index=0&id=dc9ee224&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9ee224",
  null
  
)

export default component.exports